import { isE2ERunning } from './configuration';

const isTrainingDemoRoute = () =>
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/training-demo');

export const shouldSkipIntercom = () =>
    import.meta.env.MODE === 'test' ||
    import.meta.env.VITE_REACT_APP_IS_EXTENSION === 'true' ||
    !import.meta.env.VITE_REACT_APP_INTERCOM_APP_ID ||
    isTrainingDemoRoute() ||
    isE2ERunning();
